module.exports = __webpack_public_path__ + "static/media/logo-tceal.0f112ecd.png";